export default __webpack_public_path__ + "static/media/watch-vido-icon.a3599cda.svg";